import { useState } from "react";
import { api, errorMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { UserCircle, KeyRound } from "lucide-react";

export default function Perfil() {
  const { user } = useAuth();
  const [actual, setActual] = useState("");
  const [nueva, setNueva] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [loading, setLoading] = useState(false);

  const cambiar = async (e) => {
    e.preventDefault();
    if (nueva !== confirmar) { toast.error("La confirmación no coincide con la nueva contraseña"); return; }
    if (nueva.length < 6) { toast.error("La nueva contraseña debe tener al menos 6 caracteres"); return; }
    setLoading(true);
    try {
      await api.post("/auth/cambiar-password", { password_actual: actual, password_nueva: nueva });
      toast.success("Contraseña actualizada correctamente");
      setActual(""); setNueva(""); setConfirmar("");
    } catch (err) { toast.error(errorMsg(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md space-y-6">
      <div>
        <h1 className="font-heading text-2xl font-bold flex items-center gap-2"><UserCircle size={22} /> Mi perfil</h1>
      </div>

      <div className="bg-white border border-border rounded-sm p-4 space-y-2">
        <div className="flex justify-between text-sm"><span className="text-muted-foreground">Usuario</span><span className="font-medium" data-testid="perfil-usuario">{user?.usuario}</span></div>
        <div className="flex justify-between text-sm"><span className="text-muted-foreground">Nombre</span><span className="font-medium">{user?.nombre || "—"}</span></div>
        <div className="flex justify-between text-sm"><span className="text-muted-foreground">Rol</span>
          <span className="font-semibold uppercase text-xs bg-secondary px-2 py-0.5 rounded-sm">{user?.rol === "admin" ? "Administrador" : "Estándar"}</span></div>
      </div>

      <form onSubmit={cambiar} className="bg-white border border-border rounded-sm p-4 space-y-4">
        <h2 className="font-heading font-bold flex items-center gap-2"><KeyRound size={16} /> Cambiar contraseña</h2>
        <div className="space-y-1"><Label>Contraseña actual</Label>
          <Input data-testid="password-actual-input" type="password" value={actual} onChange={(e) => setActual(e.target.value)} required /></div>
        <div className="space-y-1"><Label>Nueva contraseña</Label>
          <Input data-testid="password-nueva-input" type="password" value={nueva} onChange={(e) => setNueva(e.target.value)} required /></div>
        <div className="space-y-1"><Label>Confirmar nueva contraseña</Label>
          <Input data-testid="password-confirmar-input" type="password" value={confirmar} onChange={(e) => setConfirmar(e.target.value)} required /></div>
        <Button data-testid="cambiar-password-btn" type="submit" disabled={loading}>
          {loading ? "Guardando..." : "Cambiar contraseña"}
        </Button>
      </form>
    </div>
  );
}
